import Vue from 'vue'
import App from './App'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Vue.config.productionTip = false
Vue.use(BootstrapVue)


import './css/main.css'
import 'vue-material-design-icons/styles.css'
// import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap4";
import 'tabulator-tables/dist/css/tabulator_site.css'
// import 'tabulator-tables/dist/css/bulma/tabulator_bulma.min.css'
import './assets/icons'
import '@/pages/components'

import store from './store';

Vue.use(BootstrapVue)

// Vue.config.productionTip = false

import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts);


// https://github.com/vuejs/vue-router/issues/914#issuecomment-326536513
Vue.directive('title', {
  inserted: (el, binding) => document.title = binding.value,
  update: (el, binding) => document.title = binding.value
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})
